import { useAppSelector } from '@/Application/Hooks/Redux';
import { ErrorCode } from '@/modules/perseo-billing/containers/fallback/components/error-code/ErrorCode';
import { RetryButton } from '@/modules/perseo-billing/containers/fallback/components/retry-button/RetryButton';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src';
import {
  CardContent,
  Icon,
  Typography
} from '@/modules/perseo-billing/ui/react/src/components/beta';

export const ModalContent = ({ handleClick }: { handleClick: () => void }) => {
  const paymentError = useAppSelector((state) => state?.billing?.paymentError);
  const isMobile = useMediaQuery('xl');

  const title = paymentError?.title;
  const message = paymentError?.message;
  const errorCode = paymentError?.errorCode;
  const iconError = paymentError?.contentAssets;

  return (
    <CardContent>
      <div className="co-flex co-flex-col co-gap-32px co-justify-center co-items-center">
        {iconError && (
          <Icon
            className="co-w-[250px] co-h-[250px] lg:co-w-300px lg:co-h-[200px]"
            icon={iconError}
          />
        )}
        <div className="co-flex co-flex-col co-gap-32px co-justify-center co-items-center co-w-full lg:co-w-2/3">
          <Typography size="h2" weight="semibold" align="center">
            {title}
          </Typography>
          <Typography
            color="gray-dark"
            align="center"
            className="co-whitespace-pre-line"
          >
            {message}
          </Typography>
        </div>
        {isMobile && (
          <>
            {errorCode && <RetryButton handleClick={handleClick} />}
            {errorCode && <ErrorCode error={errorCode} />}
          </>
        )}
      </div>
    </CardContent>
  );
};
